// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.landlord.ConfirmLandlordBusinessTypeWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ConfirmLandlordBusinessTypeWebApiRequestDto } from '../..';

export const ConfirmLandlordBusinessTypeWebApiHandler_confirmBusinessType_Path =
  '/api/web/v1/landlord/confirmBusinessType';

/**
 * Confirm whether the landlord collects rent as an individual or a company
 */
export const ConfirmLandlordBusinessTypeWebApiHandler_confirmBusinessType = (
  postData: ConfirmLandlordBusinessTypeWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ConfirmLandlordBusinessTypeWebApiRequestDto, void>(
    {
      endpoint: ConfirmLandlordBusinessTypeWebApiHandler_confirmBusinessType_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
